import type { Selector, State as S } from '../../../../model/State';
import Progress from 'redux-progress';

export const selectProductPackages: Selector<unknown> = (state: S) =>
  state.mac.products.productPackages?.ifSuccess((r) => r);

export const selectEvaluationProducts: Selector<unknown> = (state: S) =>
  state.mac.products.evaluationProducts?.ifSuccess((r) => r);

export const selectCurrentProductPackage: (state: S, productKey) => {} = (state: S, productKey) =>
  state.mac.products.currentProductPackage?.[productKey]?.ifSuccess((r) => r);

export const selectBTFProducts: (state: S, addonKey: string) => Progress<any> = (
  state: S,
  addonKey: string,
): Progress<any> => {
  return state.mac.products.btfProductPackageAvailableForEvaluation?.[addonKey] || Progress.none;
};

export const selectProductPackage: (state: S, productPackageId: number) => any = (
  state: S,
  productPackageId,
) => state.mac.products.productPackage?.[productPackageId]?.ifSuccess((r) => r);
